import React from 'react';
import { Switch, Route, useLocation, Redirect } from 'react-router-dom';
import { routes, switchRoutes } from 'core/router/router';
import { CustomAutologinScene } from 'scenes/user/login/custom-autologin';
import { AutologinManager } from 'pods/autologin';
import { UnloggedScene } from 'scenes/unlogged';
import { useBuCode } from 'common/utils';
import { LookAndFeelUnloggedProvider } from 'common/context/look-and-feel-unlogged';
export const RouterUnlogged = () => {
    const location = useLocation();
    const buCode = useBuCode();
    return (React.createElement(LookAndFeelUnloggedProvider, { businessUnitCode: buCode },
        React.createElement(Switch, { location: location },
            React.createElement(Route, { exact: true, path: [switchRoutes.bu] },
                React.createElement(UnloggedScene, null)),
            React.createElement(Route, { path: [switchRoutes.autologin.base] },
                React.createElement(AutologinManager, null)),
            React.createElement(Route, { path: [switchRoutes.unlogged] },
                React.createElement(UnloggedScene, null)),
            React.createElement(Route, { exact: true, path: [switchRoutes.customAutologin] },
                React.createElement(CustomAutologinScene, null)),
            React.createElement(Route, { path: '*' },
                React.createElement(Redirect, { to: routes.bu(buCode) })))));
};
